import React from 'react'
import { motion } from 'framer-motion'

function Button({name, onClick}) {
  return (
    <motion.button
      className='bg-[#343373] px-5 py-2.5 border-none rounded-[40px] font-bold text-white'
      onClick={onClick}
      type='submit'
      whileHover={{ scale: 1.04, boxShadow: '0 10px 25px -5px rgba(52, 51, 115, 0.4)' }}
      whileTap={{ scale: 0.97 }}
      transition={{ duration: 0.2 }}
    >
      {name}
    </motion.button>
  )
}

export default Button
